export default __webpack_public_path__ + "static/media/SIAGFMEPrize_2023.5d9b99f7.pdf";